var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPreviewMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.002 1v1.5a.477.477 0 00.101.335.44.44 0 00.298.165H9.6a.44.44 0 00.298-.165.477.477 0 00.101-.335V1M6 12h4",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.333 15H4.667a1.73 1.73 0 01-1.179-.456 1.505 1.505 0 01-.488-1.1V2.556c0-.413.176-.809.488-1.1A1.729 1.729 0 014.667 1h6.666c.442 0 .866.164 1.179.456.312.291.488.687.488 1.1v10.888c0 .413-.176.809-.488 1.1a1.729 1.729 0 01-1.179.456v0z",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgPreviewMobile;